import { Flex } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import GroupButton, {
  ActionButton,
} from "components/ui/GroupButton/GroupButton";
import { SearchInput } from "components/ui/SearchInput/SearchInput";
import CustomText from "components/ui/CustomText/CustomText";
import { CommonParamsType } from "constants/types/common";
import { FORM_IDS } from "pages/BankAccount/config";
import { FC, useRef } from "react";
import { useSWRConfig } from "swr";
import { useAppModal } from "utils/hooks/ui/useAppModal";
import CreateForm from "../CreateForm/CreateForm";
import { getBankAccountListKey } from "utils/hooks/request/useBankAccount";

type BankAccountActionsProps = {
  handleSearch: (v: string) => void;
  params: CommonParamsType;
};

const BankAccountActions: FC<BankAccountActionsProps> = ({
  handleSearch,
  params,
}) => {
  const { openCrudModal, closeCrudModal } = useAppModal();
  const activeModalId = useRef<string | null>(null);
  const { mutate } = useSWRConfig();

  const handleCloseModal = () => {
    if (activeModalId.current) {
      closeCrudModal(activeModalId.current);
      activeModalId.current = null;
    }
  };

  const handleOpenCreateModal = () => {
    const modalId = openCrudModal(
      <CustomText variant="section-title">
        Tạo mới tài khoản ngân hàng
      </CustomText>,
      {
        mode: "create",
        formId: FORM_IDS.CREATE,
        children: (
          <CreateForm
            mutate={() => mutate(getBankAccountListKey(params))}
            onClose={handleCloseModal}
          />
        ),
        submitText: "Tạo mới",
      },
      600,
    );
    activeModalId.current = modalId;
  };

  const actions: ActionButton[] = [
    {
      key: "create",
      label: "Tạo mới",
      icon: <IconPlus size={18} />,
      variant: "filled",
      color: "blue",
      isLoading: false,
      onClick: handleOpenCreateModal,
      permission: "bank_account:create",
    },
  ];

  return (
    <Flex justify="space-between" align="center">
      <SearchInput
        value={params.search || ""}
        onChange={handleSearch}
        placeholder="Tìm kiếm tài khoản ngân hàng"
      />
      <GroupButton actions={actions} />
    </Flex>
  );
};

export default BankAccountActions;
